// extracted by mini-css-extract-plugin
export default {"edit_your_box":"ym","edit_box_title":"zm","subscription":"Am","byb":"Bm","recommended_for_you_title":"Cm","explore":"Em","recommended":"Fm","go_back":"Gm","wrapper":"Hm","product_img":"Im","info":"Jm","remove_btn":"Km"};
    if(module.hot) {
      // 1730991498584
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  